import { useParams } from "react-router-dom";
import { fetchBoardDetail } from "../../../utils/api/fetchBoardDetail";
import { useEffect, useState } from "react";
import { useBoard } from "../../../providers/BoardDetailProvider";
import { postBoardView } from "../../../utils/api/postBoardView";

export const useQueryBoardDetail = () => {
  const { category_id = 0, board_id = 0 } =
    useParams<{ category_id?: string; board_id: string }>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { initData } = useBoard();
  useEffect(() => {
    const getBoardDetail = async () => {
      if (!category_id || !board_id) {
        return;
      }
      try {
        await fetchBoardDetail(Number(category_id), Number(board_id)).then(
          (res) => {
            if (res.isSuccess) {
              const boardDetail = res?.result?.data;
              if (!!Object.keys(boardDetail || {}).length) {
                const { nickname = "", sei = "", mei = "" } = boardDetail ?? {};
                const authorNickname = nickname ? nickname : `${sei}${mei}`;
                const totalComments = boardDetail?.total_of_comments || 0;
                const boardDetailData = {
                  ...boardDetail,
                  nickname: authorNickname,
                };
                initData(boardDetailData, totalComments);
              }
            }
          }
        );
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    getBoardDetail();
  }, [board_id, category_id]);

  return { isLoading };
};

export const useUpdateBoardView = () => {
  const {
    state: { boardDetailData },
  } = useBoard();
  const { id = 0 } = boardDetailData ?? {};
  useEffect(() => {
    const updateBoardView = async () => {
      if (!id) {
        return;
      }
      await postBoardView(id);
    };
    updateBoardView();
  }, [id]);
  return null;
};
